import React from 'react';
import { CheckoutButton } from '../CheckoutButton';
const painPoints = [{
  emoji: '📚',
  text: "You have tons of Prosthodontics notes but aren't sure which concepts actually matter most."
}, {
  emoji: '🧠',
  text: "You understand a topic today, but a few days later you can't remember how it connects to everything else."
}, {
  emoji: '⏱️',
  text: 'Before an exam or class, you spend more time finding information than actually reviewing it.'
}, {
  emoji: '🤯',
  text: 'You keep mixing up classifications, materials, techniques, components, or clinical steps.'
}, {
  emoji: '📝',
  text: "You read for hours, but when you close your notes, you realize you can't explain the concept without looking."
}, {
  emoji: '😩',
  text: "You feel like you're memorizing isolated facts instead of seeing the bigger picture of Prosthodontics."
}];
export function FamiliarSection() {
  return <section className="bg-white px-4 py-14 sm:py-20" data-id="element-125" data-mp="333b2xnk8y4k7">
      <div className="mx-auto w-full max-w-4xl" data-id="element-126" data-mp="1x32i9dc9ygnb">
        <div className="text-center" data-id="element-127" data-mp="1x0pyqvqvby85">
          <p className="text-[11px] font-extrabold uppercase tracking-[0.18em] text-aqua-500" data-id="element-128" data-mp="1s37n2xlgv4wg">
            Does this sound familiar?
          </p>
          <h2 className="mt-3 font-display text-[26px] font-bold leading-[1.15] tracking-tight text-navy-900 sm:text-4xl" data-id="element-129" data-mp="1n2tijpj2qd36">
            If you answer <span className="italic text-aqua-500" data-id="element-130" data-mp="1e3okekbfclrj">yes</span> to any of these, PROSTHO 360™ was
            designed for you
          </h2>
        </div>

        <ul className="mt-8 grid gap-3 sm:grid-cols-2" data-id="element-131" data-mp="19bn7cw6fmr0g">
          {painPoints.map(point => <li key={point.text} className="flex gap-3.5 rounded-2xl bg-sand-50 p-4 ring-1 ring-navy-800/8 sm:p-5" data-id="element-132" data-mp="14eof6j6bwu4w">
              <span className="text-2xl leading-none" aria-hidden="true" data-id="element-133" data-mp="vdyoftvxdty1">
                {point.emoji}
              </span>
              <p className="text-[14.5px] font-medium leading-relaxed text-navy-800/85" data-id="element-134" data-mp="qfou1li0yxdh">{point.text}</p>
            </li>)}
        </ul>

        <div className="mx-auto mt-8 max-w-2xl border-l-4 border-aqua-500 pl-4 text-left sm:pl-5" data-id="element-135" data-mp="gt4b19oolexb">
          <p className="text-[15.5px] leading-relaxed text-navy-800/75 sm:text-lg" data-id="element-136" data-mp="kq0ixqaueiaj">
            And it shouldn't have to feel this way. The problem isn't that you're not studying enough—
            <strong className="font-bold text-navy-900" data-id="element-137" data-mp="btrj4aiydhnv">
              nobody gave you a system for organizing what you're studying.
            </strong>
          </p>
        </div>

        <div className="mt-8" data-id="element-138" data-mp="14fj8enbezsfm">
          <CheckoutButton label="I want a structured study system" sub="One-time payment of $27 · Lifetime access" data-id="element-139" data-mp="prg2fdxdggqt" />
        </div>
      </div>
    </section>;
}